var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInvoicesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 497,
    height: 292,
    viewBox: "0 0 497 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 102.577 135.504)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 435.62 197.863)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 279.277,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 63.8979 222.09)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 298.536 154.808)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 234.905,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 183.332 270.197)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288.073,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(0.961262 -0.275637 -0.275637 -0.961262 177.693 113.294)",
    fill: "#435E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoicesLeft);
export default __webpack_public_path__ + "static/media/no-invoices-left.4e553392fc8b04e186317a66a8e5dd1d.svg";
export { ForwardRef as ReactComponent };